// Defines human-readable versions of KeyboardEvent.keyCode:
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
const keyCodes = {
  Enter: 13,
  Space: 32,
  ArrowUp: 38,
  ArrowDown: 40,
};
export default keyCodes;
